import React from 'react';
import { Button } from 'mypages-library';
import { useTranslation } from 'react-i18next';
import { navigateToLogin } from 'common/navigationUtil';
import PageTemplate from 'common/PageTemplate/PageTemplate';
import styles from 'common/PageTemplate/PageTemplate.module.scss';

export type InvalidPhoneNumberProps = {
  supportPhoneNumber: string;
};

const InvalidPhoneNumber: React.FC<InvalidPhoneNumberProps> = ({ supportPhoneNumber }) => {
  const { t } = useTranslation();
  return (
    <PageTemplate dataTestId="change-password-invalid-phone-number">
      <h1 className={styles.title}>{t('MPL_CHANGE_PW_INVALID_PHONE_NUMBER_TITLE')}</h1>
      <p className={styles.text}>
        {t('MPL_CHANGE_PW_INVALID_PHONE_NUMBER_DESCRIPTION', { phone: supportPhoneNumber })}
      </p>
      <Button
        text={t('MPL_CREATE_ACCOUNT_VERIFY_LOG_IN')}
        primary
        onClick={navigateToLogin}
        className={styles.confirmButton}
        dataTestId="change-password-invalid-phone-number-btn"
      />
    </PageTemplate>
  );
};

export default InvalidPhoneNumber;
